// TODO: these styles are estimated, there is no style information in ticket
// I have posed the question in the ticket comments:
// https://jira.apps.union-investment.de/browse/PB2B-4367
:host {
  display: block;

  address {
    color: $ui-blue;
    font-style: normal;
    margin-left: 16px;
  }

  .address-container {
    display: flex;
    justify-content: center;
    font-size: 24px;
    font-weight: 600;
    margin: 16px 0 50px;
  }

  .spinner {
    display: flex;
    justify-content: center;
  }
}
